module.exports = __webpack_public_path__ + "static/media/sharpko-large-catalog-list.285753bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Sharpko/sharpko-large-catalog-list.jpg
// module id = 695
// module chunks = 0